export default "__VITE_ASSET__BFunRQq8__"